// Local PWA assets — official SignalAgent logo (full, on white bg).
// We always show the COMPLETE logo (shield + "SignalAgent" text + ✓-!-!
// decoration). No cropping anywhere.
export const LOGO_LOCAL = "/brand/signalagent-logo.png";
export const LOGO_PUBLIC_URL =
  "https://customer-assets.emergentagent.com/job_alerte-immobilier/artifacts/rdvon8po_LOGO%20SignalAgent%20%281%29.png";

/**
 * @param {{
 *  size?: number,
 *  className?: string,
 *  withRing?: boolean,
 * }} props
 *
 * The official SignalAgent logo is a 1024×1024 square. We render it at the
 * requested square `size` so the entire logo is always visible.
 */
export default function Logo({
  size = 56,
  className = "",
  withRing = false,
}) {
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      data-testid="sa-logo"
    >
      <img
        src={LOGO_LOCAL}
        alt="SignalAgent"
        width={size}
        height={size}
        draggable={false}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
        }}
      />
      {withRing ? (
        <>
          <span className="sa-ring" />
          <span className="sa-ring delay-1" />
        </>
      ) : null}
    </div>
  );
}
